/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const StandardListItemFrag = `
    fragment StandardListItemFrag on StandardListItem {
  id
  value
  label
  description
}
    `
export const ListResponseFrag = `
    fragment ListResponseFrag on ListResponse {
  key
  list {
    ...StandardListItemFrag
  }
}
    `
export const ProgramSettingsFrag = `
    fragment ProgramSettingsFrag on ProgramSettings {
  lists {
    goalReminderTemplates {
      ...StandardListItemFrag
    }
  }
  flags {
    isWellness
    clinicalNotesActive
    oooCoveringProviderActive
  }
  appointmentSettings {
    flags {
      useSchedulingAppt
    }
  }
  layout {
    careManagerMainNav {
      id
      hidden
    }
    careManagerPatientNav {
      id
      hidden
    }
    practiceManagerMainNav {
      id
      hidden
    }
    hideStartSessionButton
  }
  providerSettings {
    specialties {
      ...StandardListItemFrag
    }
    languages {
      ...StandardListItemFrag
    }
    modalities {
      ...StandardListItemFrag
    }
    spirituality {
      ...StandardListItemFrag
    }
    tags {
      ...StandardListItemFrag
    }
    chat {
      disablePatientChatToggleActive
      patientChatDisabledByDefault
      unreadChatActive
      unreadEvents
      highlightedWords
    }
    flags {
      sessionTimeout
    }
  }
}
    `
export const AppendListItemsDocument = `
    mutation appendListItems($key: String!, $input: [AppendListItemInput!]!) {
  appendListItems(key: $key, input: $input) {
    ...StandardListItemFrag
  }
}
    ${StandardListItemFrag}`
export const UpdateListItemsDocument = `
    mutation updateListItems($key: String!, $input: [UpdateListItemInput!]!) {
  updateListItems(key: $key, input: $input) {
    ...StandardListItemFrag
  }
}
    ${StandardListItemFrag}`
export const DeleteListItemsDocument = `
    mutation deleteListItems($key: String!, $input: [ID!]!) {
  deleteListItems(key: $key, input: $input) {
    ...StandardListItemFrag
  }
}
    ${StandardListItemFrag}`
export const GetListDocument = `
    query getList($keys: [String!]!, $forceInvalidate: Boolean) {
  getList(keys: $keys, forceInvalidate: $forceInvalidate) {
    ...ListResponseFrag
  }
}
    ${ListResponseFrag}
${StandardListItemFrag}`
export const GetProgramSettingsDocument = `
    query getProgramSettings($forceInvalidate: Boolean) {
  getProgramSettings(forceInvalidate: $forceInvalidate) {
    ...ProgramSettingsFrag
  }
}
    ${ProgramSettingsFrag}
${StandardListItemFrag}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    appendListItems: build.mutation<
      Types.AppendListItems,
      Types.AppendListItemsVariables
    >({
      query: (variables) => ({ document: AppendListItemsDocument, variables }),
    }),
    updateListItems: build.mutation<
      Types.UpdateListItems,
      Types.UpdateListItemsVariables
    >({
      query: (variables) => ({ document: UpdateListItemsDocument, variables }),
    }),
    deleteListItems: build.mutation<
      Types.DeleteListItems,
      Types.DeleteListItemsVariables
    >({
      query: (variables) => ({ document: DeleteListItemsDocument, variables }),
    }),
    getList: build.query<Types.GetList, Types.GetListVariables>({
      query: (variables) => ({ document: GetListDocument, variables }),
    }),
    getProgramSettings: build.query<
      Types.GetProgramSettings,
      Types.GetProgramSettingsVariables | void
    >({
      query: (variables) => ({
        document: GetProgramSettingsDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
